import { Component, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/fieldconfig.interface';
import { SharedService } from '../../../../app/shared/services/shared.service';
import { LocalStorageService } from '../../../localstorage.service';
import { AppConfig } from 'app/app.config';
import { SharedConfig } from './../../../../app/shared/shared.config';
import { DomSanitizer } from '@angular/platform-browser';
import { EventBusService } from 'framework/eventbus.service';

@Component({
  selector: 'form-esignature',
  styleUrls: ['form-esignature.component.scss'],
  templateUrl: './form-esignature.component.html'
})

export class FormESignatureComponent implements Field {
  config: FieldConfig;
  group: FormGroup;
  imgSrc: any;
  isSignatureEmpty: boolean = false;

  constructor(private _sharedService: SharedService,
    private localStorage: LocalStorageService,
    public _eventBus: EventBusService,
    private sanitizer: DomSanitizer) {
    this.imgSrc = '';
    this.prepareSignature();
    let that = this;  
    this._eventBus.signatureSaved$.subscribe(data => {
      that.prepareSignature();
    });
  }

  private prepareSignature() {
    let wfId: any = this.localStorage.getItem("workflow_instance_id");
    let that = this;
    this._sharedService.getSignatureByWorkflowId(wfId).subscribe(response => {
      if (!response || response.trim() === '' || response == null){
        that.isSignatureEmpty = true;
      } else {
        that.imgSrc = this.sanitizer.bypassSecurityTrustResourceUrl(SharedConfig.getbase64ImageAppend() + response);
        that.isSignatureEmpty = false;
      }
    }, error => {
      console.error("Image load error!!!");
    });
  }

}
